import { Fragment, useContext, useEffect, useState } from 'react';
import { RoomContext } from '../../contexts/RoomContext';
import ListRoom from '../../components/layout/rooms/ListRoom';
import AddRoomModal from '../../components/layout/rooms/AddRoomModal';
import { AuthContext } from '../../contexts/AuthContext';
import { ROLES, PERMISSIONS, NO_PERMISSION } from '../../contexts/constants';
import { CruiseContext } from '../../contexts/CruiseContext';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const Room = () => {
	const { t } = useTranslation();
	const { setShowAddRoomModal } = useContext(RoomContext);

	const {
		authState: { user }
	} = useContext(AuthContext);
	const {
		cruiseState: { cruises }
	} = useContext(CruiseContext);

	const [cruiseOptions, setCruiseOptions] = useState([]);
	const [currentCruise, setCurrentCruise] = useState({});

	useEffect(() => {
		if (cruises && cruises.length > 0) {
			const cruiseOpts = cruises.map((cruise) => {
				return {
					label: cruise.name,
					value: cruise.id
				};
			});
			setCruiseOptions(cruiseOpts);
			setCurrentCruise(cruiseOpts[0]);
		}
	}, [cruises]);

	const handleCruiseChange = (cruise) => {
		setCurrentCruise(cruise);
	};
	const customStyles = {
		menuPortal: (provided) => ({ ...provided, zIndex: 5 })
	};
	if (!user) {
		return NO_PERMISSION;
	}

	if (user.Roles.length == 1 && user.Roles.includes(ROLES.PARTNER)) return NO_PERMISSION;
	if (!(user.Permissions.includes(PERMISSIONS.GET_ROOM) || user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR))) {
		return NO_PERMISSION;
	}
	return (
		<Fragment>
			<div className='horizontal-mainwrapper container-fluid clearfix'>
				<div className='explain-dashboard mt-5'>
					<div className='explain-header mb-3'>
						<div className='row'>
							<div className='col-md-4'>
								<h3 className='pull-left'>{t('Room List')}</h3>
							</div>
							<div className='col-md-2 ml-auto'>
								{user.Permissions.includes(PERMISSIONS.INSERT_ROOM) ||
								user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR) ? (
									<button
										className='right-content btn btn-success btn-block'
										onClick={setShowAddRoomModal.bind(this, true)}
									>
										<i className='fe fe-plus-circle'></i> {t('Add Room')}
									</button>
								) : null}
							</div>
						</div>
						<hr />
						<div className=''>
							<h5>{t('Filter')}</h5>
						</div>
						<div className='row'>
							<div className='col-md-3'>
								<div className='form-group'>
									<label>{t('Cruise')}</label>

									<Select
										isClearable
										name='cruise_id'
										onChange={handleCruiseChange.bind(this)}
										options={cruiseOptions}
										placeholder={t('Choose Cruise')}
										value={currentCruise}
										menuPosition={'fixed'}
										styles={customStyles}
									/>
								</div>
							</div>
						</div>
					</div>
					<ListRoom cruise={currentCruise} />
					<AddRoomModal />
				</div>
			</div>
			<div className='margin-bottom-150'></div>
		</Fragment>
	);
};

export default Room;
